//// Application Packages
import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { subtractValuesAdditionalBooleanForm } from '../../functions/form-functions'

//// Application Slices
import { selectSettings } from '../../reducers/settingSlice'
import {
    updateFormData,
    updateFormAuxiliary,
    deleteFormData,
    selectForms,
} from '../../reducers/formSlice'

//// Application Components

//// Carbon Components
import { Checkbox } from '@carbon/react'

//// Carbon Icons

//// Static Constants

//////// Component
const CheckContactFormComponent = () => {
    //////// Hooks
    const dispatch = useDispatch()

    //////// State
    const [checked, setChecked] = useState(false)

    //////// Slices
    const settingsData = useSelector(selectSettings)
    const formsData = useSelector(selectForms)

    //// Slice Data
    const digital_name = settingsData?.['form']?.['digital_name']

    //////// Search Params

    //////// Methods

    //////// Functional Methods

    // Handle Setting Of Checkbox On Load
    const handleSetStateChecked = () => {
        const checked = formsData?.[digital_name]?.auxiliary?.checked
        if (checked) {
            setChecked(checked)
        } else {
            setChecked(false)
        }
    }

    // Handle Check Of Contact Form Component
    const handleCheckContactFormComponent = async () => {
        if (formsData?.[digital_name]?.auxiliary?.checked) {
            dispatch(
                updateFormAuxiliary({
                    digital_name: digital_name,
                    auxiliary: {
                        checked: false,
                        practice_location: true,
                    },
                })
            )
            setChecked(false)
        } else {
            dispatch(
                updateFormAuxiliary({
                    digital_name: digital_name,
                    auxiliary: {
                        checked: true,
                        practice_location: false,
                    },
                })
            )
            setChecked(true)
        }
        const values = subtractValuesAdditionalBooleanForm(
            formsData?.[digital_name]?.auxiliary,
            formsData?.[digital_name]?.values
        )
        if (values) {
            dispatch(
                deleteFormData({
                    digital_name: digital_name,
                })
            )
            dispatch(
                updateFormData({
                    digital_name: digital_name,
                    values: values,
                })
            )
        }
    }

    //////// Memoization

    //////// Effects/Side Effects

    // Check Settings & Set Checkbox On Load
    useEffect(() => {
        handleSetStateChecked()
        return () => {}
    }, [])

    //////////////// Render & Return
    return (
        <>
            <nav className="half-width-checkbox-with-paragraph-group">
                <div className="half-width-checkbox-with-paragraph-group-item">
                    <p>Address Same As Mailing Address</p>
                </div>
                <div className="half-width-checkbox-with-paragraph-group-item">
                    <fieldset className="cds--fieldset">
                        <Checkbox
                            className="fldoh-checkbox"
                            labelText=""
                            id="checked"
                            checked={checked}
                            onClick={handleCheckContactFormComponent}
                        />
                    </fieldset>
                </div>
            </nav>
        </>
    )
}

export default CheckContactFormComponent
